__webpack_require__.p = "https://appsprod.cibercolegios.com/inscription/";